module.exports = __webpack_public_path__ + "static/hero-top-e2d7fec15890d1a79eeea0947d8a9116.png";